// extracted by mini-css-extract-plugin
export default {"node":"NodeTypes_node__AWP5d","content":"NodeTypes_content__EZk9m","handle":"NodeTypes_handle__5W7dP","placeholder":"NodeTypes_placeholder__+JuZU"};